import { z } from 'zod';

// Shared between backend (controller DTO + use case input) and frontend (form
// + API client). Zones are location-scoped resources managed by Org Admins
// (JQ4-11 / US-ORG-003).

export const ZoneStatusSchema = z.enum(['active', 'inactive']);
export type ZoneStatus = z.infer<typeof ZoneStatusSchema>;

export const CreateZoneRequestSchema = z.object({
  name: z.string().trim().min(1, 'Name is required').max(120),
  // capacity: 0 is INVALID (min(1)); null = unlimited; omitted = null.
  capacity: z.number().int().min(1).max(99999).nullable().optional(),
});
export type CreateZoneRequest = z.infer<typeof CreateZoneRequestSchema>;

export const UpdateZoneRequestSchema = CreateZoneRequestSchema.partial();
export type UpdateZoneRequest = z.infer<typeof UpdateZoneRequestSchema>;

export const ZoneResponseSchema = z.object({
  id: z.string().uuid(),
  locationId: z.string().uuid(),
  organizationId: z.string().uuid(),
  name: z.string(),
  capacity: z.number().int().nullable(),
  status: ZoneStatusSchema,
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type ZoneResponse = z.infer<typeof ZoneResponseSchema>;

export const ListZonesResponseSchema = z.object({ zones: z.array(ZoneResponseSchema) });
export type ListZonesResponse = z.infer<typeof ListZonesResponseSchema>;
